import React, { useState } from 'react';
import { BsPencilSquare, BsAward, BsX, BsArrowUp, BsArrowDown, BsCheckCircle } from 'react-icons/bs';
import styles from '../../HedefFormu.module.css';

const PatentCard = ({ data, onEdit }) => {
  const [showEditModal, setShowEditModal] = useState(false);

  const TARGET = {
    ulusalPatent: 2,
    uluslararasiPatent: 1,
    ulusalTasarim: 2,
    uluslararasiTasarim: 1,
    ulusalFaydaliModel: 2,
    uluslararasiFaydaliModel: 1
  };

  const completionStatus = {
    ulusalPatent: data.ulusalPatent >= TARGET.ulusalPatent,
    uluslararasiPatent: data.uluslararasiPatent >= TARGET.uluslararasiPatent,
    ulusalTasarim: data.ulusalTasarim >= TARGET.ulusalTasarim,
    uluslararasiTasarim: data.uluslararasiTasarim >= TARGET.uluslararasiTasarim,
    ulusalFaydaliModel: data.ulusalFaydaliModel >= TARGET.ulusalFaydaliModel,
    uluslararasiFaydaliModel: data.uluslararasiFaydaliModel >= TARGET.uluslararasiFaydaliModel
  };

  const totalPatent = data.ulusalPatent + data.uluslararasiPatent;
  const targetPatent = TARGET.ulusalPatent + TARGET.uluslararasiPatent;

  const totalTasarim = data.ulusalTasarim + data.uluslararasiTasarim;
  const targetTasarim = TARGET.ulusalTasarim + TARGET.uluslararasiTasarim;

  const totalFaydaliModel = data.ulusalFaydaliModel + data.uluslararasiFaydaliModel;
  const targetFaydaliModel = TARGET.ulusalFaydaliModel + TARGET.uluslararasiFaydaliModel;

  const totalContributions = totalPatent + totalTasarim + totalFaydaliModel;
  const targetTotal = targetPatent + targetTasarim + targetFaydaliModel;

  const handleEdit = () => {
    setShowEditModal(true);
  };

  return (
    <div className={styles.card} data-type="patent">
      <div className={styles.cardHeader}>
        <h3 className={styles.cardTitle}>
          <BsAward className={styles.cardIcon} />
          Patent ve Faydalı Model
        </h3>
        <div className={styles.cardActions}>
          <button 
            className={styles.actionButton}
            onClick={handleEdit}
            aria-label="Patent ve faydalı modelleri düzenle"
          >
            <BsPencilSquare />
          </button>
        </div>
      </div>

      <div>
        <div className={styles.formSection}>
          <h4 className={styles.formTitle}>Patent</h4>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Ulusal Patent
              {completionStatus.ulusalPatent && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.ulusalPatent})</span>
            </span>
            <div className={styles.statValue}>{data.ulusalPatent}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Uluslararası Patent
              {completionStatus.uluslararasiPatent && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.uluslararasiPatent})</span>
            </span>
            <div className={styles.statValue}>{data.uluslararasiPatent}</div>
          </div>
          <div className={styles.targetStatus}>
            <div className={styles.targetItem}>
              <span>Toplam:</span>
              <span className={totalPatent >= targetPatent ? styles.targetComplete : styles.targetIncomplete}>
                {totalPatent} / {targetPatent}
              </span>
            </div>
          </div>
        </div>

        <div className={styles.formSection}>
          <h4 className={styles.formTitle}>Tasarım Tescili</h4>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Ulusal Tasarım
              {completionStatus.ulusalTasarim && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.ulusalTasarim})</span>
            </span>
            <div className={styles.statValue}>{data.ulusalTasarim}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Uluslararası Tasarım
              {completionStatus.uluslararasiTasarim && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.uluslararasiTasarim})</span>
            </span>
            <div className={styles.statValue}>{data.uluslararasiTasarim}</div>
          </div>
          <div className={styles.targetStatus}>
            <div className={styles.targetItem}>
              <span>Toplam:</span>
              <span className={totalTasarim >= targetTasarim ? styles.targetComplete : styles.targetIncomplete}>
                {totalTasarim} / {targetTasarim}
              </span>
            </div>
          </div>
        </div>

        <div className={styles.formSection}>
          <h4 className={styles.formTitle}>Faydalı Model</h4>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Ulusal Faydalı Model
              {completionStatus.ulusalFaydaliModel && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.ulusalFaydaliModel})</span>
            </span>
            <div className={styles.statValue}>{data.ulusalFaydaliModel}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Uluslararası Faydalı Model
              {completionStatus.uluslararasiFaydaliModel && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.uluslararasiFaydaliModel})</span>
            </span>
            <div className={styles.statValue}>{data.uluslararasiFaydaliModel}</div>
          </div>
          <div className={styles.targetStatus}>
            <div className={styles.targetItem}>
              <span>Toplam:</span>
              <span className={totalFaydaliModel >= targetFaydaliModel ? styles.targetComplete : styles.targetIncomplete}>
                {totalFaydaliModel} / {targetFaydaliModel}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.totalSection}>
        <div className={styles.totalRow}>
          <span>Toplam Patent</span>
          <div>{totalPatent} / {targetPatent}</div>
        </div>
        <div className={styles.totalRow}>
          <span>Toplam Tasarım</span>
          <div>{totalTasarim} / {targetTasarim}</div>
        </div>
        <div className={styles.totalRow}>
          <span>Toplam Faydalı Model</span>
          <div>{totalFaydaliModel} / {targetFaydaliModel}</div>
        </div>
        <div className={styles.totalRow} style={{ marginTop: '12px', fontWeight: 'bold' }}>
          <span>Toplam Katkı</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {totalContributions} / {targetTotal}
            <span className={totalContributions >= targetTotal ? styles.trendUp : styles.trendDown}>
              {totalContributions >= targetTotal ? <BsArrowUp /> : <BsArrowDown />}
              {Math.abs(targetTotal - totalContributions)}
            </span>
          </div>
        </div>

        <div className={styles.progressBar}>
          <div 
            className={styles.progressFill} 
            style={{ width: `${(totalContributions / targetTotal) * 100}%` }} 
          />
          <span className={styles.progressLabel}>
            {`${((totalContributions / targetTotal) * 100).toFixed(1)}% (Hedef: ${targetTotal})`}
          </span>
        </div>
      </div>

      {showEditModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.modal} data-type="patent">
            <div className={styles.modalHeader}>
              <h2 className={styles.modalTitle}>
                <BsAward /> Patent ve Faydalı Model Hedeflerini Düzenle
              </h2>
              <button 
                className={styles.actionButton}
                onClick={() => setShowEditModal(false)}
                aria-label="Kapat"
              >
                <BsX size={24} />
              </button>
            </div>
            
            <form className={styles.modalForm}>
              <div className={styles.formSection}>
                <h3 className={styles.formTitle}>Patent</h3>
                <p className={styles.detailsLabel}>
                  2025 yılı içerisinde başvurusu yapılması planlanan faydalı modellerin sayısını belirtiniz.
                </p>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Ulusal Patent (Hedef: {TARGET.ulusalPatent})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.ulusalPatent}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Uluslararası Patent (Hedef: {TARGET.uluslararasiPatent})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.uluslararasiPatent}
                      min="0"
                    />
                  </div>
                </div>
              </div>

              <div className={styles.formSection}>
                <h3 className={styles.formTitle}>Faydalı Model</h3>
                <p className={styles.detailsLabel}>
                  2025 yılı içerisinde başvurusu yapılması planlanan patentlerin sayısını belirtiniz.
                </p>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Ulusal Faydalı Model (Hedef: {TARGET.ulusalFaydaliModel})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.ulusalFaydaliModel}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Uluslararası Faydalı Model (Hedef: {TARGET.uluslararasiFaydaliModel})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.uluslararasiFaydaliModel}
                      min="0"
                    />
                  </div>
                </div>
              </div>

              <div className={styles.formSection}>
                <h3 className={styles.formTitle}>Endüstriyel Tasarım</h3>
                <p className={styles.detailsLabel}>
                  2025 yılı içerisinde başvurusu yapılması planlanan endüstriyel tasarımların sayısını belirtiniz.
                </p>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Ulusal Tasarım (Hedef: {TARGET.ulusalTasarim})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.ulusalTasarim}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Uluslararası Tasarım (Hedef: {TARGET.uluslararasiTasarim})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.uluslararasiTasarim}
                      min="0"
                    />
                  </div>
                </div>
              </div>

              <div className={styles.buttonContainer}>
                <button 
                  className={styles.cancelButton}
                  onClick={() => setShowEditModal(false)}
                >
                  İptal
                </button>
                <button className={styles.saveButton}>
                  Kaydet
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default PatentCard; 